<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/teachers/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>تنظیمات اساتید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field color="black" label="رمز عبور تمام اساتید در انتظار تایید به مقدار زیر تغییر یابد"
                          v-model="settings.passwords">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-text-field color="black" label="به تعداد عدد زیر از اعلان های اساتید پاک شود"
                          v-model="settings.delete_notification_count">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn block color="success" @click="updateSettings">اعمال تغییرات</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "TeacherSetting",
  data() {
    return {
      settings: {
        passwords: null,
        delete_notification_count: 0,
      }
    }
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    getSettings() {
      window.axios.get('setting/instructors/index').then((res) => {
        this.settings = res.data.data
      })
    },
    updateSettings() {
      window.axios.post('setting/instructors/update', {
        passwords: this.settings.passwords,
        delete_notification_count: this.settings.delete_notification_count
      }).then(() => {
        this.openSnackbar('تنظیمات اساتید با موفقیت ویرایش شد.', 'success')
        this.getSettings()
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>